/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { pd, Theme, Corner } from '@airasia-phoenix/react-native/tokens';
import { DateTimeParser } from '@airasia-phoenix/react-native/utils';
export {
  pd,
  Theme,
  ButtonState,
  Font,
  Corner,
  Icon,
  Colour,
} from '@airasia-phoenix/react-native/tokens';
export {
  DateTimeFormat,
  DateTimeParser,
  DateTimeFormatter,
} from '@airasia-phoenix/react-native/utils';

export const parseDate = DateTimeParser.parseDate;
// expos pd and theme
export const lightTheme = Theme.lightTheme;
export const darkTheme = Theme.darkTheme;

export const overlay = {
  content: '""', // Required for the pseudo-element to display
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  pointerEvents: 'none', // Ensure the overlay doesn't block clicks.
  zIndex: 1,
};

export function shapeFrom(token: string): Corner {
  switch (token) {
    case 'pd.sys.shape.corner.extra_small':
      return pd.sys.shape.corner.extra_small;
    default:
    case 'pd.sys.shape.corner.small':
      return pd.sys.shape.corner.small;
    case 'pd.sys.shape.corner.large':
      return pd.sys.shape.corner.large;
    case 'pd.sys.shape.corner.extra_large':
      return pd.sys.shape.corner.extra_large;
    case 'pd.sys.shape.corner.full':
      return pd.sys.shape.corner.full;
  }
}
